import * as types from './actionTypes';
import * as authTypes from '../authentication/actionTypes';

const initalState = {
  UserList: [],
  exportUserList: [],
  editUserSuccess: false,
  role: [],
  addUserSuccess: false,
  inActiveUserSuccess: false,
  updateUrlsSuccess: false,
  updateUrlsError: {},
  updateUserSuccess: false,
  updateUserError: null,
  userDetails: null,
  isSwitchingRole: false,
  isSwitched: null,
};

export const userReducer = (state = initalState, action) => {
  const { type } = action;
  switch (type) {
    case types.SET_USER_LIST:
      return {
        ...state,
        UserList: action.payload,
      };
    case types.SET_USER_EXPORT_LIST:
      return {
        ...state,
        exportUserList: action.payload,
      };
    case types.SET_ROLE:
      return {
        ...state,
        role: action.payload,
      };
    case types.INACTIVE_USER_SUCCESS:
      return {
        ...state,
        inActiveUserSuccess: action.payload,
      };
    case types.UPDATE_URL_SUCCESS:
      return {
        ...state,
        updateUrlsSuccess: action.payload,
      };
    case types.UPDATE_URL_ERROR:
      return {
        ...state,
        updateUrlsError: action.payload,
      };
    case types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUserSuccess: action.payload,
        updateUserError: null,
      };
    case types.UPDATE_USER_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
      };
    case types.SWITCH_ROLE:
      return {
        ...state,
        isSwitchingRole: true,
      };
    case types.SWITCH_ROLE_SUCCESS:
      return {
        ...state,
        isSwitchingRole: false,
        isSwitched: action.payload,
      };
    case authTypes.LOGIN_SUCCESS:
      return {
        ...state,
        // Fresh logins should not inherit a stale switched-session flag from persisted state.
        // Real switched sessions are set explicitly by SWITCH_ROLE_SUCCESS in switchRole saga.
        isSwitched: false,
      };
    case authTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isSwitchingRole: false,
        isSwitched: null,
      };
    case types.SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
      };
    case types.CLEAR_USER_DETAILS:
      return {
        ...state,
        userDetails: null,
      };

    default:
      return state;
  }
};
